{
  "loading": "Se încarcă...",
  "placeholder": "Selectați o opțiune"
}